<template>
  <div>
    <el-row v-for="(chart, index) in $root.unusedChartPresenceList" :key="index">
      <div @click="OnRemove(chart.name)">
        <el-card shadow="always">
          {{ chart.displayName }}
        </el-card>
      </div>
    </el-row>
   
  </div>
</template>

<script>
export default {
  name: "RealTimePresenceSettingMenu",
  methods: {
    OnRemove(title) {
      let list = this.$root.unusedChartPresenceList;
      for (let index in list) {
        if (list[index].name === title) {
          this.$root.usedChartPresenceList.push(
            this.$root.unusedChartPresenceList[index]
          );
          this.$root.unusedChartPresenceList.splice(index, 1);
        }
      }
      localStorage.setItem('usedChartPresenceList', JSON.stringify(this.$root.usedChartPresenceList))
      if (this.$root.usedChartPresenceList.length <= 5) {
        this.$root.barscrollFlg = "false";
      } else {
        this.$root.barscrollFlg = "true";
      }
    },
  },
};
</script>


<style>
</style>
